module.exports = __webpack_public_path__ + "static/img/711_phase_function_Paper_PointsHejduk_Prediction.18da9ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/711_phase_function_Paper_PointsHejduk_Prediction.png
// module id = LB1A
// module chunks = 0